// extracted by mini-css-extract-plugin
export var interview = "interviews-section-module--interview--7aaa6";
export var interviewAuthor = "interviews-section-module--interviewAuthor--07f4d";
export var interviewAuthorImage = "interviews-section-module--interviewAuthorImage--ec212";
export var interviewAuthorInfo = "interviews-section-module--interviewAuthorInfo--cc909";
export var interviewBody = "interviews-section-module--interviewBody--5bb98";
export var interviewBodyContent = "interviews-section-module--interviewBodyContent--21012";
export var interviewCta = "interviews-section-module--interviewCta--0d96a";
export var interviewHeader = "interviews-section-module--interviewHeader--6c3a4";
export var interviewHeaderImage = "interviews-section-module--interviewHeaderImage--8e0fa";
export var interviewWrapperInfo = "interviews-section-module--interviewWrapperInfo--9689e";
export var interviewWrapperInfoSeparator = "interviews-section-module--interviewWrapperInfoSeparator--73d34";
export var itemList = "interviews-section-module--itemList--edb43";
export var section = "interviews-section-module--section--1496b";
export var title = "interviews-section-module--title--cf0c4";